import { getResource } from "./api";

// The signed-in reporter's V1 mutes, read by V2 over the FDW: [{ userId, createdAt, durationDays }]
// (userId is the muted user's V1 id, which pitch rows carry as user_migrate_id)
const mine = async () => {
  const { data, error } = await getResource("/v1_link/api/reporter_mutes");
  if (error) return { error };
  return { data: (data && data.data) || [] };
};

export default { mine };
